
export const dateLocaleRu = {
    days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
    daysShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    months: [
      "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
      "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
    ],
    monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    firstDayOfWeek: 1,
    format24h: true,
    pluralDay: "дней",
    prevMonth: "Предыдущий месяц",
    nextMonth: "Следующий месяц",
    prevYear: "Предыдущий год",
    nextYear: "Следующий год",
    today: "Сегодня",
  };